import "UI/Widget/Forms/Control/Element";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Select = Class(UI.Widget.Forms.Control.Element, {
    createElement: function() {
        let onSelect = this.$control.attr("on-select");
        let attributes = {};
        let selected = this.$control.attr("selectedValue");
        try {
            selected = JSON.parse(selected);
        } catch(e) {};
        let showEmpty = this.$control.attr("show-empty") !== undefined;
        let source = null;
        let value = this.$control.attr("value-key") || "value";
        try {
            value = JSON.parse(value);
        } catch(e) {};

        let title = this.$control.attr("title-key") || "title";

        if (onSelect) {
            attributes["on-change"] = onSelect;
        }

        if (this.$control.attr("source")) {
            source = _.get(this.parent, this.$control.attr("source"));
        }

        this.$element = UI.Template.$render("UI/Widget/Forms/Control/Select/Control", {
            selected: selected,
            attributes: attributes,
            source: source,
            value: value,
            title: title,
            showEmpty: showEmpty
        });

        if (this.disabled) {
            this.$element.prop("disabled", true);
        }
    },

    insertElement: function() {
        let self = this;

        this.ParentCall();

        this.$element.on("change", function() {
            let val = this.value;
            try {
                val = JSON.parse(val);
            } catch(e) {}
            self.setValue(val);
        });
    },

    updateElement: function(value) {
        if (_.isArray(value) || _.isObject(value)) {
            value = JSON.stringify(value);
        }
        value = Util.coalesce(value, "");

        $("[value=\'" + value + "\']", this.$element).prop("selected", true);
    }
});
